<div class="grid mx-3">
  <div class="col-12 sm:col-6">
    <p>
      <b>Home Address</b>
      <span *ngIf="primaryAddress?.isPrimary"> - Primary</span>:<br />
      {{ primaryAddress.address1 || 'N/A' }}<br *ngIf="primaryAddress.address2">
      {{ primaryAddress.address2 }}<br />
      {{ primaryAddress.city }}{{ primaryAddress.city ? ', ' : '' }}
      {{ primaryAddress.state }} {{ primaryAddress.zipcode }}
    </p>

    <p>
      <b>Business Address</b>
      <span *ngIf="businessAddress?.isPrimary"> - Primary</span>:<br />
      {{ businessAddress.address1 || 'N/A' }}<br *ngIf="businessAddress.address2">
      {{ businessAddress.address2 }}<br />
      {{ businessAddress.city }}{{ businessAddress.city ? ', ' : '' }}
      {{ businessAddress.state }} {{ businessAddress.zipcode }}
    </p>
  </div>

  <div class="col-12 sm:col-6">
    <p>
      <b>Home Phone:</b> {{ phoneNumber || 'N/A' }}<br />
      <b>Cell Phone:</b> {{ cellPhone || 'N/A' }}
    </p>
    <p>
      <b>Primary Email:</b> {{ emailAddress || 'N/A' }}<br />
      <b>Work Email:</b> {{ workEmailAddress || 'N/A' }}
    </p>
  </div>
</div>
